"use client";

// Components
import {
  FeaturedProducts,
  HomepageCategories,
  HomepageSlider,
  PopularCategories,
  ProductsGroups,
} from "@workspace/ui/widgets";
import React from "react";

import { useGlobal } from "@/context";

export default function MainCategoryListing() {
  const {
    state: {
      homepageImageSlider,
      popularCategories,
      loadingHomepage,
      homepageCategories,
      productsGroups,
      featuredProducts,
    },
  } = useGlobal();

  return (
    <div className="max-w-screen-2xl mx-auto">
      <HomepageSlider
        slides={homepageImageSlider["odziez-damska"] || []}
        isLoading={loadingHomepage}
      />

      <HomepageCategories
        homepageCategories={homepageCategories["odziez-damska"] || []}
        isLoading={loadingHomepage}
      />

      <ProductsGroups productGroups={productsGroups["odziez-damska"] || []} />

      <FeaturedProducts
        products={featuredProducts["odziez-damska"] || []}
        isLoading={loadingHomepage}
      />

      <PopularCategories
        popularCategories={popularCategories || []}
        selectedPage="/odziez-damska"
        isLoading={loadingHomepage}
      />
    </div>
  );
}
